import {
  PulseFilters,
  PulsePaginatedFilters,
  pulseFiltersSchema,
  pulsePaginatedFiltersSchema,
} from './types'

import { api } from 'api'
import { z } from 'zod'

const topComplaintsResponse = z.array(
  z.object({
    complaint: z.string(),
    num_complaints: z.number(),
  })
)

export type TopComplaints = z.infer<typeof topComplaintsResponse>

export async function getTopComplaints(
  filters: PulsePaginatedFilters,
  signal?: AbortSignal
) {
  const data = pulsePaginatedFiltersSchema.parse(filters)
  return api
    .post('/company/pulse/performance/top_complaints', data, { signal })
    .then((res) => res.data.top_complaints ?? [])
}

export async function getTopComplaintsCsv(
  filters: PulseFilters,
  signal?: AbortSignal
) {
  const data = pulseFiltersSchema.parse(filters)
  return api
    .post('/company/pulse/performance/top_complaints/csv', data, { signal })
    .then((response) => response.data)
}
